import { computed } from 'vue'

import { usePostHog } from '@/common/composables/usePostHog'

// Feature flag centralization
export function useFeatureFlags() {
  const posthog = usePostHog()

  const isHoldManagementEnabled = computed(() => posthog.isFeatureEnabled('hold_management'))

  const isMassEmailEnabled = computed(() => posthog.isFeatureEnabled('mass_email'))

  const isSettingEmailTemplatesEnabled = computed(() =>
    posthog.isFeatureEnabled('setting-email-templates'),
  )

  const isNewImageCropperApiEnabled = computed(() =>
    posthog.isFeatureEnabled('new_image_cropper_api'),
  )

  const isSalesReportsEnabled = computed(() =>
    posthog.isFeatureEnabled('automatic-sales-reporting'),
  )

  return {
    isHoldManagementEnabled,
    isMassEmailEnabled,
    isSettingEmailTemplatesEnabled,
    isNewImageCropperApiEnabled,
    isSalesReportsEnabled,
  }
}
